// Turns what someone types into the tokens stored in `searchTokens` by the
// Cloud Functions (functions/lib/derive.js — keep the two in sync).
// Firestore can match one token per query, so the longest word is sent to
// Firestore and the rest are checked on the results.

export const MAX_WORD_TOKEN = 12;
const MAX_KEY_TOKEN = 16;
const MIN_TOKEN = 2;

export function normalize(text) {
  return String(text || "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase();
}

// "AB12-CD34" -> ["ab12cd34"]; "Hotel Atlântico" -> ["hotel", "atlantico"]
export function searchWords(term) {
  const text = normalize(term).trim();
  if (/^[0-9a-f]{2,4}(-[0-9a-f]{0,4})+$/.test(text)) {
    return [text.replace(/-/g, "").slice(0, MAX_KEY_TOKEN)];
  }
  const words = (text.match(/[\p{L}\p{N}]+/gu) || [])
    .filter((w) => w.length >= MIN_TOKEN)
    .map((w) =>
      /^[0-9a-f]+$/.test(w) && w.length > MAX_WORD_TOKEN
        ? w.slice(0, MAX_KEY_TOKEN)
        : w.slice(0, MAX_WORD_TOKEN),
    );
  return [...new Set(words)];
}

// The word Firestore filters on: the longest, i.e. the most selective.
export const primaryToken = (words) =>
  words.reduce((best, word) => (word.length > best.length ? word : best), "");

export const matchesAllWords = (doc, words) =>
  words.every((word) => (doc.searchTokens || []).includes(word));
